import React, { useState } from 'react';
import { Button, Drawer, Link, Loading, MessagePlugin, Popconfirm } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { DeleteIcon } from 'tdesign-icons-react';
import { fetchTenantDetail } from '@/slices/kopTenantSlice';
import { deleteTenant, updateTenant } from '@/services/kopTenantService';
import ModalHeader from '@/components/Header/Modal';
import Descriptions from '@/components/Descriptions';
import PermWrapper from '@/components/PermWrapper';
import EllipsisTip from '@/components/EllipsisTip';
import QuickGrant from '../QuickGrant';
import Summary from '../Summary';

function Detail({ clusterName, tenant, fetchTenantDetail, detail, onDelete, loading }) {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const showDetail = () => {
    setVisible(true);
    loadDetail();
  };

  const loadDetail = () => {
    fetchTenantDetail({
      clusterName,
      tenant,
    });
  };

  const onNoteChange = async (note) => {
    try {
      await updateTenant({
        clusterName,
        tenant: detail.tenant,
        user: detail.user,
        app: detail.app,
        note,
      });
      MessagePlugin.success('修改成功！');
      loadDetail();
    } catch (error) {
      return false;
    }
  };

  const handleDelete = async () => {
    await deleteTenant({
      clusterName,
      tenant,
    });
    MessagePlugin.success('删除成功！');
    setVisible(false);
    onDelete();
  };

  return (
    <>
      <Link onClick={showDetail} theme='primary'>
        {tenant}
      </Link>
      <Drawer
        size={1000}
        destroyOnClose
        header={
          <ModalHeader
            tags={[clusterName, detail.tenant]}
            tail={
              <PermWrapper resource='kop:tenant:list:delete'>
                <Popconfirm theme='danger' content='确定删除？' onConfirm={handleDelete}>
                  <Button theme='danger' variant='outline' size='small' icon={<DeleteIcon />}>
                    删除
                  </Button>
                </Popconfirm>
              </PermWrapper>
            }
          >
            租户
          </ModalHeader>
        }
        visible={visible}
        onClose={onClose}
        onOverlayClick={onClose}
        footer={null}
      >
        <Loading loading={loading}>
          <Body>
            <Summary overview={detail} />
            <Descriptions title='基本信息' style={{ marginTop: 20 }}>
              <Descriptions.Item label='租户名' value={detail.tenant} />
              <Descriptions.Item label='集群名称' value={detail.clusterName} />
              <Descriptions.Item label='创建时间' value={detail.createTime} type='datetime' />
              <Descriptions.Item label='负责人' value={detail.user} />
              <Descriptions.Item label='所属应用' value={detail.app} />
              {detail.note && ( // 业务逻辑
                <Descriptions.Item
                  label='备注'
                  value={detail.note}
                  editable
                  render={(val) => <EllipsisTip>{val}</EllipsisTip>}
                  onChange={onNoteChange}
                />
              )}
            </Descriptions>

            <H3>租户管理员</H3>
            <QuickGrant
              onUpdate={loadDetail}
              tenant={tenant}
              tenantAdminRoleList={detail.tenantAdminRoleList || []}
            />
          </Body>
        </Loading>
      </Drawer>
    </>
  );
}

export default connect(
  (state) => ({
    detail: state.kopTenant.detail,
    loading: state.kopTenant.detailFetching,
  }),
  {
    fetchTenantDetail,
  },
)(Detail);

const H3 = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: var(--td-font-gray-1);
  padding: 12px 0 6px;
`;

const Body = styled.div`
  margin-top: -15px;
`;
